export interface Package {
  id: string
  name: string
  rate: string
  duration: string
  description: string
  type: string
}

export interface Therapist {
  firstName: string
  id: string
  name: string
  title: string
  experience: string
  image: string
  specialties: string[]
  insurances: string[]
  rate: string
  packages: Package[]
  city?: string
  state?: string
  location?: string
  distance?: string
  rating?: number
  reviews?: number
  latitude?: number
  longitude?: number
  specialization?: any[]
  insuranceAccepted?: any[]
  selectedPackage: Package | null
}

export const toCaps = (value?: string) => {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
}

export function formatTimestampWithDuration(timestamp, durationMinutes) {
  // Validate timestamp
  const start = new Date(timestamp)
  if (isNaN(start.getTime())) return '--'

  // Validate duration
  if (typeof durationMinutes !== 'number' || isNaN(durationMinutes)) return '--'

  const end = new Date(start.getTime() + durationMinutes * 60000)
  if (isNaN(end.getTime())) return '--'

  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  const timeFormatter = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  })

  return `${dateFormatter.format(start)} ${timeFormatter.format(start)} - ${timeFormatter.format(end)}`
}

// Format therapist data (your existing function)
export const formatTherapistData = (t: any): Therapist => {
  return {
    id: t?.id,
    name: t?.name,
    title: t?.title,
    experience: t?.experience,
    image: t?.image,
    rating: t?.rating,
    reviews: t?.reviews,
    city: t?.city,
    state: t?.state,
    distance: t?.distance,
    rate: t?.rate,
    specialties: Array.isArray(t?.specialization)
      ? t.specialization.map((s: any) => s?.name || '')
      : [],
    insurances: Array.isArray(t?.insuranceAccepted)
      ? t.insuranceAccepted.map((i: any) => i?.payer_name || '')
      : [],
    packages: Array.isArray(t?.packages)
      ? t.packages.map((p: any) => ({
          id: p?.id,
          name: p?.name,
          rate: p?.rate,
          duration: p?.session_length || '45 mins',
          description: p?.description || '',
          type: 'Online',
        }))
      : [],
    latitude: t?.latitude,
    longitude: t?.longitude,
    location: t?.location,
    specialization: [],
    insuranceAccepted: [],
    firstName: '',
    selectedPackage: null,
  }
}
